const dictionary = {
  userStatus: {
    description: '用户状态',
    options: [
      { value: 0, label: '正常' },
      { value: 1, label: '关闭' }
    ]
  },
  optimizeLogType: {
    description: '优化日志类型',
    options: [
      { value: 0, label: '其他' },
      { value: 1, label: '关键词布局' },
      { value: 2, label: '站内优化' },
      { value: 3, label: '站外优化' }
    ]
  },
  industrys: {
    description: '从事行业',
    options: [{
      label: "安全安保",
      value: "100"
    }, {
      label: "办公文教",
      value: "200"
    }, {
      label: "彩票",
      value: "300"
    }, {
      label: "成人用品",
      value: "400"
    }, {
      label: "电脑硬件",
      value: "500"
    }, {
      label: "软件游戏",
      value: "600"
    }, {
      label: "电子电工",
      value: "700"
    }, {
      label: "法律服务",
      value: "800"
    }, {
      label: "房地产",
      value: "900"
    }, {
      label: "服装鞋帽",
      value: "1000"
    }, {
      label: "礼品饰品",
      value: "1100"
    }, {
      label: "广播通信",
      value: "1200"
    }, {
      label: "广告及包装",
      value: "1300"
    }, {
      label: "网络服务",
      value: "1400"
    }, {
      label: "化工及材料",
      value: "1500"
    }, {
      label: "机械设备",
      value: "1600"
    }, {
      label: "建筑及装修",
      value: "1700"
    }, {
      label: "交通运输",
      value: "1800"
    }, {
      label: "教育培训",
      value: "1900"
    }, {
      label: "节能环保",
      value: "2000"
    }, {
      label: "金融服务",
      value: "2100"
    }, {
      label: "铃声短信",
      value: "2200"
    }, {
      label: "旅游及票务",
      value: "2300"
    }, {
      label: "农林牧渔",
      value: "2400"
    }, {
      label: "商务服务",
      value: "2500"
    }, {
      label: "生活服务",
      value: "2600"
    }, {
      label: "生活用品",
      value: "2700"
    }, {
      label: "食品餐饮",
      value: "2800"
    }, {
      label: "休闲娱乐",
      value: "2900"
    }, {
      label: "家用电器",
      value: "3000"
    }, {
      label: "图书音像",
      value: "3100"
    }, {
      label: "医疗健康",
      value: "3200"
    }, {
      label: "招商加盟",
      value: "3300"
    }, {
      label: "化妆品",
      value: "3400"
    }, {
      label: "孕婴用品",
      value: "3500"
    }, {
      label: "其他",
      value: "9900"
    }]
  },
  workType: {
    description: '工单类别',
    options: [{
      label: "关闭任务（退款）",
      value: "26"
    }, {
      label: "更换优化师（任务重发）",
      value: "23"
    }, {
      label: "加词",
      value: "20"
    }, {
      label: "停词",
      value: "21"
    }, {
      label: "停搜索引擎",
      value: "29"
    }, {
      label: "加搜索引擎",
      value: "28"
    }, {
      label: "网站问题/技术问题",
      value: "40"
    }, {
      label: "排名效果不好",
      value: "41"
    }, {
      label: "扣费问题",
      value: "42"
    }, {
      label: "关键词排名不准确",
      value: "43"
    }, {
      label: "财务",
      value: "46"
    }, {
      label: "发票",
      value: "45"
    }, {
      label: "提现",
      value: "27"
    }, {
      label: "账号问题",
      value: "47"
    }, {
      label: "其他",
      value: "44"
    }]
  },
  workStatus: {
    description: '工单状态',
    options: [{
      label: "待处理",
      value: "-1"
    }, {
      label: "处理中",
      value: "0"
    }, {
      label: "已同意",
      value: "1"
    }, {
      label: "未同意",
      value: "2"
    }]
  },
  taskStatus: {
    description: '任务状态',
    options: [{
      label: "待发布", // 搜索用
      value: 50
    }, {
      label: "待审核",
      value: 54
    }, {
      label: "审核不通过",
      value: 55
    }, {
      label: "优化中", // 搜索用
      value: 10
    }, {
      label: "扣费中",
      value: 2
    }, {
      label: "已关闭",
      value: 4
    }]
  },
  searchEngine: {
    description: '搜索引擎',
    options: [{
      label: "百度",
      value: 1
    }, {
      label: "360搜索",
      value: 3
    }, {
      label: "搜狗",
      value: 4
    }, {
      label: "谷歌",
      value: 2
    }, {
      label: "手机百度",
      value: 5
    }, {
      label: "神马",
      value: 6
    }, {
      label: "手机搜狗",
      value: 7
    }]
  },
  keywordState: {
    description: '关键词状态',
    options: [{
      label: '待审核',
      value: 0
    }, {
      label: '未通过',
      value: 1
    }, {
      label: '正常运行',
      value: 2
    }, {
      label: '申请停用',
      value: 3
    }, {
      label: '已经停用',
      value: 4
    }, {
      label: '申请启用',
      value: 5
    }]
  },
  keywordOrderState: {
    description: '关键词工单状态',
    options: [{
      label: '申请停词中',
      value: 1
    }, {
      label: '延迟停词中',
      value: 2
    }, {
      label: '申请加词中',
      value: 4
    }]
  },
  stopWordReason: {
    description: '停词理由',
    options: [{
      label: '优化效果不理想',
      value: 1
    }, {
      label: '优化师没有做相关的优化工作',
      value: 2
    }, {
      label: '优化时间超过却依旧未见排名',
      value: 3
    }, {
      label: '已经寻求到其他合作的优化公司',
      value: 4
    }, {
      label: '这个网站已经下线了',
      value: 5
    }, {
      label: '云客网处理问题不及时',
      value: 6
    }, {
      label: '其它',
      value: 7
    }]
  },
  "flowType": {
    "description": "财务流水类型",
    "options": [{
      "value": 1,
      "label": "账户充值"
    }, {
      "value": 2,
      "label": "站点预存"
    }, {
      "value": 3,
      "label": "服务费"
    }, {
      "value": 4,
      "label": "站点预存退还"
    }, {
      "value": 5,
      "label": "站点服务费退还"
    }, {
      "value": 6,
      "label": "账户退款"
    }, {
      "value": 212,
      "label": "余额提现"
    }, {
      "value": 26,
      "label": "包年预存"
    }, {
      "value": 29,
      "label": "包年服务费流水类型"
    }, {
      "value": 219,
      "label": "其他业务转出"
    }]
  },
  withdrawStatus: {
    description: '提现状态',
    options: [{
      label: '待审核',
      value: 0
    }, {
      label: '审核不通过',
      value: 1
    }, {
      label: '已打款',
      value: 2
    }, {
      label: '审核通过',
      value: 3
    }]
  }
}
export default dictionary



// WEBPACK FOOTER //
// ./src/common/dictionary.js